import { Injectable } from '@angular/core';
import { Action, NgxsOnInit, Selector, State, StateContext } from '@ngxs/store';
import * as actions from './ui-backdrop.actions';

export interface UIBackdropModel {
	active: boolean;
}

@State<UIBackdropModel>({
	name: 'uiBackdrop',
	defaults: {
		active: false,
	},
})
@Injectable()
export class UIBackdropState implements NgxsOnInit {
	ngxsOnInit(ctx: StateContext<UIBackdropModel>): void {}

	@Selector([UIBackdropState])
	static getBackdropState(state: UIBackdropModel): boolean {
		return state.active;
	}

	@Action(actions.ToggleBackDrop)
	toggleBackDrop(ctx: StateContext<UIBackdropModel>): void {
		const state = ctx.getState();

		ctx.patchState({
			active: !state.active,
		});
	}

	@Action(actions.ActivateBackdrop)
	activateBackdrop(ctx: StateContext<UIBackdropModel>): void {
		ctx.patchState({
			active: true,
		});
	}

	@Action(actions.DeactivateBackdrop)
	deactivateBackdrop(ctx: StateContext<UIBackdropModel>): void {
		ctx.patchState({
			active: false,
		});
	}
}
